import React from 'react'
import styled from 'styled-components'
import { imageUrl, postUrl } from '@libs/appUrl'

/**
 * related component:
 *   /web/src/components/ArticleCard/index.js
 */

type Img = {
  thumb: string
}

type Props = {
  postID: string
  img: Img[]
  title: string
  text: string
  userInfo: {
    name: string
    img: string
  }
  like: number
}

const Container = styled.a`
  background: #fff;
  padding: 15px;
  display: grid;
  grid-gap: 15px;
  grid-template-columns: minmax(0, 1fr) 80px;
  margin-bottom: 10px;
`

const Title = styled.div`
  line-height: 2em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
`

const Text = styled.div`
  font-size: 0.9em;
  line-height: 1.5;
  max-height: 4.5em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
`

const UserInfoContainer = styled.div`
  grid-area: 2 / 1 / span 1 / span 2;
  color: rgba(0, 0, 0, 0.68);
  font-size: 0.8em;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) 18px auto;
  grid-gap: 5px;
  align-items: center;
`

function ArticleCard(props: Props) {
  const { title, text, like, postID } = props
  const thumbnailPath = props.img?.[0]?.thumb
  const { name, img } = props.userInfo
  const url = postUrl(postID)

  return (
    <Container href={url}>
      <div>
        <Title dangerouslySetInnerHTML={{ __html: title }} />
        <Text dangerouslySetInnerHTML={{ __html: text }} />
      </div>
      {thumbnailPath && (
        <amp-img
          width="80"
          height="80"
          src={imageUrl(thumbnailPath)}
          style={{ borderRadius: '4px 4px 0 0' }}
        />
      )}
      <UserInfoContainer>
        <amp-img width="18" height="18" src={imageUrl(img)} style={{ borderRadius: '50%' }} />
        <div dangerouslySetInnerHTML={{ __html: name }} />
        <amp-img width="18" height="18" src={imageUrl('img/globalicon/like01.png')} />
        <div>{like}</div>
      </UserInfoContainer>
    </Container>
  )
}

export default ArticleCard
